<template>
    <el-container class="container">
    <!-- 头部区域 -->
    <el-header style="height:70px" v-if="showHead">
      <Headbar ></Headbar>
    </el-header>
    <!-- 主体区域 -->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside width="200px">
        <!-- <div v-if="showHead" @click="back" class="toggle-button">
          <div class="bg" style="width:100%;height:26px"></div>
        </div> -->
        <div v-if="showHead" @click="back" class="toggle-button" style="display:flex;align-items: center;justify-content: center;margin-bottom: 10px;margin-bottom:20px">
          <div class="bg" style="width:10px;height:26px;margin-right:10px; align-items: center;"></div>
          <span style="font-size:14px">返回</span>
        </div>
        <Sidebar></Sidebar>
      </el-aside>
      <!-- 右侧内容 -->
      <el-main>
        <!-- <div class="breadcrumb-header">
          <Breadcrumb/>
        </div>    -->
        <div class="view">
          <div>
              <router-view ref="view"/>
          </div>
        </div>
        <template v-if="showHead">
          <div @click="addRecheck" class="circle1">
            <i class="el-icon-edit icon"></i>
          </div>
          <div @click="showRecheckTable" class="circle">
            <i class="el-icon-s-grid icon"></i>
          </div>
          <div @click="send" class="circle2">
            <i class="el-icon-chat-dot-square icon"></i>
          </div>
        </template>
      </el-main>
    </el-container>
      <el-dialog
        :close-on-click-modal="false"
        title="复核意见"
        :visible.sync="dialogVisible"
        width="1200px">
        <recheck-table ref="recheckTable"></recheck-table>
      </el-dialog>
      <addOrUpdateForm data_class="Recheck" @refreshTable="refreshTable" ref="addOrUpdateForm"></addOrUpdateForm>
    </el-container>
</template>

<script>
import addOrUpdateForm from '../../recheck/addOrUpdateForm'
import {api} from '@/api/api'
import RecheckTable from '../../recheck/table'
import * as types from '@/vuex/types'
import Headbar from './../HeadBar'
import Sidebar from './Sidebar'
// import * as types from '@/vuex/types'
export default {
  components: {
    Headbar,
    Sidebar,
    RecheckTable,
    addOrUpdateForm
  },
  data () {
    return {
      dialogVisible: false,
      showHead: true,
      iscollapse: false
    }
  },
  mounted () {
    if (this.$route.query.companyId && this.$route.query.controlId) {
      this.showHead = false
      this.$store.commit(types.COMPANY_ID, this.$route.query.companyId)
      this.$store.commit(types.CONTROL_ID, this.$route.query.controlId)
      this.$store.commit(types.SESSION_ID, this.$route.query.sid)
    }
  },
  destroyed () {
    this.$store.commit(types.COMPANY_ID, null)
  },
  methods: {
    refreshTable () {
      if (this.$refs['recheckTable']) {
        this.$refs['recheckTable'].getList()
      }
    },
    back () {
      this.$router.push('/enterpriseManagement/index')
      this.$store.commit(types.COMPANY_ID, null)
    },
    addRecheck () {
      this.$refs['addOrUpdateForm'].showForm()
    },
    showRecheckTable () {
      this.dialogVisible = true
    },
    send () {
      this.$confirm('点击确定将发送短信提醒单位有新的复核要求?', '提示', {
        confirmButtonText: '确定发送',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(
          api[`sendReviewMessage`],
          {company_id: this.$store.state.companyId}
        ).then(response => {
          if (response.data.code === 0) {
            this.$message({
              type: 'success',
              message: '发送成功'
            })
          } else {
            this.$message({
              type: 'warning',
              message: '发送失败 ' + response.data.msg
            })
          }
        }).catch(error => {
          console.log(error)
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
  .container {
    height: 100%;
    /* font-family: 'SimHei'  */
    font-family: 'YaHei';
  }
  .el-header {
    background-color: #5190fb;
    padding-right: 0
  }
  /* .el-aside {
    background-color: #fff;
  } */
  .el-main {
    padding: 0;
    /* height: 100%; */
    background-color: #eaedf1;
  }
  .main {
    position: relative;
  }
  .circle {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 30px;
    bottom: 200px;
    border-radius: 50%;
    background: #409EFF;
    -webkit-box-shadow:0px 3px 3px #c8c8c8 ;
    -moz-box-shadow:0px 3px 3px #c8c8c8 ;
    box-shadow:0px 3px 3px #c8c8c8 ;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 999;
  }

  .circle1 {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 30px;
    bottom: 270px;
    border-radius: 50%;
    background: #409EFF;
    -webkit-box-shadow:0px 3px 3px #c8c8c8 ;
    -moz-box-shadow:0px 3px 3px #c8c8c8 ;
    box-shadow:0px 3px 3px #c8c8c8 ;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 999;
  }
  .circle2 {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 30px;
    bottom: 130px;
    border-radius: 50%;
    background: #409EFF;
    -webkit-box-shadow:0px 3px 3px #c8c8c8 ;
    -moz-box-shadow:0px 3px 3px #c8c8c8 ;
    box-shadow:0px 3px 3px #c8c8c8 ;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 999;
  }
  .icon {
    color: #fff;
    font-size: 18px;
  }
  .el-menu {
    border-right: none !important;
  }
  .toggle-button {
    background-color: #89b1f7;
    font-size: 10px;
    line-height: 24px;
    color: #fff;
    text-align: center;
    letter-spacing: 0.2em;
    cursor: pointer;
  }
  .bg {
    background: url(../../../assets/img/login/back.png) no-repeat center;
    background-size: 25px 25px;
  }
  .breadcrumb-header {
    z-index: 99;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    height: 24px;
    padding: 5px 0 0 15px;
    background-color: #fff;
    box-shadow: 1px 1px 1px #ccc;
  }
  .el-aside {
    overflow: auto;
    /* padding: 0; */
  }
  .view {
    margin: 10px;
    /* margin-top: 24px; */
    margin-bottom: 0;
    padding: 10px;
    padding-bottom:0 ;
    min-height: calc(100vh - 94px);
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/frame/company/CompanyHome.vue